import axios from 'axios';

const api = axios.create({
  baseURL: '/api',
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('sessionToken');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
      console.log('API request with token:', config.url);
    } else {
      console.log('API request without token:', config.url);
    }
    return config;
  },
  (error) => {
    console.error('API request interceptor error:', error);
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('API response error:', {
      url: error.config?.url,
      status: error.response?.status,
      data: error.response?.data,
    });

    // Any authenticated request failing with 401/403 means the session is
    // dead — clear it and send the user to the login page. Skip the login
    // flow itself so a failed sign-in doesn't loop.
    const status = error.response?.status;
    const url: string = error.config?.url || '';
    const isAuthRoute = url.includes('/authorize');
    const onLoginPage = window.location.pathname.startsWith('/login');
    if ((status === 401 || status === 403) && !isAuthRoute && !onLoginPage) {
      console.log('Session invalid — clearing and redirecting to /login');
      localStorage.removeItem('user');
      localStorage.removeItem('sessionToken');
      localStorage.removeItem('sessionExpiration');
      window.location.assign('/login');
    }
    return Promise.reject(error);
  }
);

export default api;